module.exports = __webpack_public_path__ + "static/media/5.5d2048c3.png";